import {getPublicEnv} from "../../utils/public-env";

export type PublicEnvVar = keyof ReturnType<typeof getPublicEnv>;

export const PublicEnv: Partial<Record<PublicEnvVar, unknown>> = getPublicEnv();

export const getPublicEnvVar = (VAR: PublicEnvVar): unknown => PublicEnv[VAR];
